import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(() => ({
    divider: {
        background: '#DEDEE7',
        height: 1,
        width: '100%'
    }
}));
